import React from "react";
import { Snackbar, useMediaQuery, SnackbarOrigin, Alert, Typography } from '@mui/material';
import { Theme, useTheme } from '@mui/material/styles';
import Slide from '@mui/material/Slide';

///
/// Definições
///
const SNACK_TIME = 5000;

///
/// Types
///
export type SnackStatusMessage = 'error'|'info'|'success'|'warning';
type fnAbrir = (msg: string, tipo?: SnackStatusMessage, autoHide?: boolean) => void;
type fnFechar = () => void;

///
/// Delegate
///
export interface IBananinhaDelegate {
	abrir: fnAbrir;
	fechar: fnFechar;
}

class BananinhaDelegate implements IBananinhaDelegate
{
	abrir: fnAbrir;
	fechar: fnFechar;

	constructor(abrir: fnAbrir, fechar: fnFechar)
	{
		this.abrir = abrir;
		this.fechar = fechar;
	}
}

function TransitionUp(props) {
	return <Slide {...props} direction="up" />;
}

///
/// Componente
///
interface IProps {
	getDelegate?: (delegate: IBananinhaDelegate) => void
}

const Bananinha : React.FC<IProps> = (props) => 
{
	const theme: Theme = useTheme();

	///
	/// States
	///
	const [snackOpen, setSnackOpen] = React.useState(false);
	const [snackContent, setSnackContent] = React.useState("");
	const [snackType, setSnackType] = React.useState<SnackStatusMessage>("info")
	const [snackAutoHide, setSnackAutoHide] = React.useState(true);

	///
	/// Ações
	///
	const fnOpen = React.useCallback((msg: string, tipo: SnackStatusMessage = "info", autoHide: boolean = true) =>
	{
		setSnackContent(msg);
		setSnackType(tipo);
		setSnackOpen(true);
		setSnackAutoHide(autoHide);

		// if(tipo === "success" || tipo === "info")
		// 	setSnackTimeout(true);
		// else
		// 	setSnackTimeout(false);
	}, [setSnackContent, setSnackType, setSnackOpen, setSnackAutoHide]);

	const fnClose = React.useCallback((event?: React.SyntheticEvent, reason?: string) => 
	{
		if (reason === 'clickaway')  return;
		setSnackOpen(false);
	}, [setSnackOpen]);

	///
	/// Delegate
	///
	React.useEffect(()=>{
		props.getDelegate && props.getDelegate(new BananinhaDelegate(fnOpen, fnClose));
	}, [props, fnOpen, fnClose]);

	///
	/// Render
	///
	const mediaQueryIsSM = useMediaQuery(theme.breakpoints.down('sm'))
	let snack_position: SnackbarOrigin = {horizontal: "right", vertical: "top"};
	if(mediaQueryIsSM) snack_position = {horizontal: "right", vertical: "top"};
	
	return <Snackbar open={snackOpen} 
		autoHideDuration={snackAutoHide ? SNACK_TIME : null} 
		onClose={fnClose}
		anchorOrigin={snack_position}
		TransitionComponent={TransitionUp}
		transitionDuration={500}
>
		<Alert onClose={fnClose} severity={snackType} variant="filled">
			<Typography component="span" dangerouslySetInnerHTML={{ __html: snackContent || "" }} />
		</Alert>
	</Snackbar>
}

export default Bananinha;